<template>
  <v-row no-gutters class="" id="tela-agenda">
    <v-col cols="12">
      <div class="titulo-agenda">
        <br /><br />
        <img
          src="@/assets/icone_casa_home_school.svg"
          style="height: 42px;"
          alt=""
        /><br />
        Marcar aula<br />
        particular de<br />
        <span>Em casa </span><br />
        <br /><br />
      </div>
      <HomeSchoolCalendar></HomeSchoolCalendar>
      <div class="text-center">
        <v-btn
          class="mt-10 px-5"
          color="#FFFFFF"
          rounded
          outlined
          @click="clearSubject"
        >
          <span>voltar</span>
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import SubjectProfessorsDialog from "@/components/dialogs/SubjectProfessorsDialog";
import HomeSchoolCalendar from "./homeschool/HomeSchoolCalendar";

export default {
  components: {
    SubjectProfessorsDialog,
    HomeSchoolCalendar
  },
  props: {
    subject: Object,
    affiliateId: Number
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("professorsModule", ["professorsBySubject"]),
    ...mapState("professorsModule", [
      "professors",
      "selectedProfessor",
      "freeTimes"
    ])
  },
  mounted() {},
  methods: {
    ...mapActions("professorsModule", ["loadFreeTimes"]),
    ...mapMutations("professorsModule", ["setSelectedProfessor"]),
    ...mapMutations(['clearSubject'])
  }
};
</script>

<style>
.titulo-agenda {
  text-align: center;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 7px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.7;
  padding: 16px 0;
}
.titulo-agenda span {
  font-size: 36px;
  font-weight: 900;
  color: #44ff99;
  letter-spacing: 1px;
  line-height: 1.2;
}
</style>
